export const locale = {
  lang: 'en',
  data: {
    LOGIN: {
      TITLE: 'Welcome to IT OneView!',
      TIP: "Please sign-in to your account and start the adventure",
      FORGOT_PASSWORD: "Forgot Password ?",
      REMEMBER: "Remember Me",
      SIGN_IN: "Sign in",
      SIGN_UP_TIP: "New on our platform?",
      SIGN_UP: "Create an account",
      ERROR: "Email or password incorrect"
    },
    REGISTER: {
      TITLE: "Adventure starts here 🚀",
      TIP: "Make your app management easy and fun!",
      AGREE: "I agree to",
      AGREEMENT: "privacy policy & terms",
      SIGN_UP: "Sign up",
      SIGN_IN_TIP: "Already have an account?",
      SIGN_IN: "Sign in instead",
    },
    FORGOT: {
      TITLE: "Forgot Password? 🔒",
      INSTRUCTIONS: "Enter your email and we'll send you instructions to reset your password",
      EMAIL_REQUIRED: "Email is required",
      EMAIL_VALID: "Email must be a valid email address",
      SEND_EMAIL: "Send reset link",
      BACK_TO_LOGIN: "Back to login",
    },
    RESET: {
    },
    FORM: {
      FIRST_NAME: "First name",
      LAST_NAME: "Last name",
      EMAIL: "Email",
      PHONE: "Phone number",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm password",
      GENDER: "Gender",
      BIRTH_DATE: "Birth date",
      COUNTRY: "Country",
      STREET: "Street",
      CITY: "City",
      POSTAL_CODE: "Postal code",
      REQUIRED: "is required"
    },
    GENDER: {
      MEN: "Men",
      WOMEN: "Women",
      OTHER: "Other"
    }
  }
}